import React from 'react';

export type RouteParams = {
  index?: true;
  path: string;
  Element: React.ComponentType;
  children?: RouteParams[];
};

export enum RoutesPath {
  SEND_TO_GC = 'sendToGc',
  TRANSACTIONS = 'transactions',
  MY_CLIENTS = 'myClients',
  UNIQUE_UFC_QUIZ = 'myCompany/compliance/ufc-center/quizzes/:id',
  SELLING_TOOLS = 'sellingTools',
  MY_COMPANY = 'myCompany',
  SUPPORT = 'support',
  CALENDAR = 'calendar',
  PROMOTIONS = 'promotions',
  ADMIN = 'admin',
  PROFIL = 'profile',
  HOME = '*',
  EQUISOFT = 'equisoft',
  SEARCH = 'search',
}

export enum AdminSubRoutesPath {
  NEWS = 'news',
  CALENDAR = 'calendar',
  ALERTS = 'alerts',
  BLOCKED_TRANSACTIONS = 'blockedTransactions',
}

export enum SellingToolsSubRoutesPath {
  LIFE_INSURANCE = 'lifeInsurance',
  LIVING_BENEFITS = 'livingBenefits',
  PROTEK_SOLUTIONS = 'protekSolutions',
  MORTGAGE = 'mortgage',
  INVESTMENTS = 'investments',
  GROUP_INSURANCE = 'groupInsurance',
  ENTREPRENEUR_MARKET = 'entrepreneurMarket',
  PRIVATE_MARKET = 'privateMarket',
  TRAVEL_INSURANCE = 'travelInsurance',
}

export enum CompanyItemSubRoutesPath {
  COMPLIANCE = 'compliance',
  BUSINESS_DEVELOPMENT = 'businessDevelopment',
  BUSINESS_PRACTICES = 'businessPractices',
  CONTRACT_MANAGEMENT = 'contractManagement',
}

export enum ClientsItemSubRoutesPath {
  TOOLS = 'tools',
}
